import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as support from '../../actions/support';
import * as youtubeModal from '../../actions/youtube-modal';
import { Subscription, Observable } from 'rxjs';
import { SocialMediaLinks } from '../../interfaces';

@Component({
  selector: 'edge-support-football',
  templateUrl: './support-football.component.html',
  styleUrls: ['./support-football.component.scss']
})
export class PageSupportFootballComponent implements OnInit {
  sport = 'Football';
  header1 = 'Getting Started Using Drills';
  videos1 = [
    {
      title: 'Getting Started',
      youtubeid: '?list=PLsqKy31p7W7RDv8rT4tTMCucLOWUKgNwP',
      youtubethumb: '/assets/images/support/thumbs/gettingstarted.jpg',
      description: `
        Pre-loaded example playbooks and drills to immediately start coaching your
        players (Spread, Pro-Style, Wing T)`
    },
    {
      title: 'Accessing Drills',
      youtubeid: 'sZaI5GJ96Y4',
      youtubethumb: '/assets/images/support/thumbs/accessingdrills.jpg',
      description: `
        Plug and play drills which include instructions and controls for you to
        drill at your own pace`
    },
    {
      title: 'Viewing in 3D',
      youtubeid: '1v1qRfd4E8Y',
      youtubethumb: '/assets/images/support/thumbs/controllingthecamera.jpg',
      description: `With one click, view the field from any angle with 1st and 3rd person views`
    },
    {
      title: 'User Management',
      youtubeid: 'IEgkSYB9fxw',
      youtubethumb: '/assets/images/support/thumbs/usermanagement.jpg',
      description: `Create a new user on your team to view and edit plays`
    },
    {
      title: 'Change Team Settings',
      youtubeid: 'uF3Ua2IDi8w',
      youtubethumb: '/assets/images/support/thumbs/changeteamsettings.jpg',
      description: `Tailor GoArmy Edge settings to fit your coaching style`
    }
  ];

  header2 = 'Customizing Drills and Plays';
  videos2 = [
    {
      title: 'Copy Example Playbook',
      youtubeid: 'M0WCS-Y4chs',
      youtubethumb: '/assets/images/support/thumbs/copyexampleplaybook.jpg',
      description: `Copy an example playbook in order to customize to your team and scheme`
    },
    {
      title: 'Renaming Formations, Plays, and Drills',
      youtubeid: 'qq-G71AVfY4',
      youtubethumb:
        '/assets/images/support/thumbs/renamingformationsplaysanddrills.jpg',
      description: `Copy example playbooks to rename contents to fit your terminology`
    },
    {
      title: 'Changing Drill Settings',
      youtubeid: 'AwvvcHce_R8',
      youtubethumb: '/assets/images/support/thumbs/changingdrillsettings.jpg',
      description: `Adjust drill time and hide play information during drills`
    },
    {
      title: 'Change Uniforms',
      youtubeid: 'zSr4M5be6HY',
      youtubethumb: '/assets/images/support/thumbs/changeuniforms.jpg',
      description: `Choose your team uniform and create uniforms for upcoming opponents`
    },
    {
      title: 'Changing Jersey Numbers',
      youtubeid: '76SX4qLcjAo',
      youtubethumb: '/assets/images/support/thumbs/changingjerseynumbers.jpg',
      description: `Highlight key personnel by customizing jersey labels and adding numbers`
    },
    {
      title: 'Hiding Players and Adding Floating IDs',
      youtubeid: 'voO5G02N7-4',
      youtubethumb:
        '/assets/images/support/thumbs/hidingplayersandaddingfloatingids.jpg',
      description: `Hide positions for more focused drills and add floating ID's for quick recognition`
    },
    {
      title: 'Editing Formations',
      youtubeid: 'Qaeeu5El3lg',
      youtubethumb: '/assets/images/support/thumbs/editingformations.jpg',
      description: `Drag players to customize formations and use ruler for exact player alignment`
    }
  ];

  header3 = 'Advanced Features';
  videos3 = [
    {
      title: 'Whiteboard Mode',
      youtubeid: 'f9dF7d8tLEQ',
      youtubethumb: '/assets/images/support/thumbs/whiteboardmode.jpg',
      description: `Practice play-drawing and chalk talk plays`
    },
    {
      title: 'Drawing Player Movement',
      youtubeid: 'FcZt8FbsA34',
      youtubethumb: '/assets/images/support/thumbs/drawingplayermovement.jpg',
      description: `Draw pre-play or post-snap movement while fine tuning path
                    speed and movement type`
    },
    {
      title: 'Changing Possession',
      youtubeid: 'HqSQ3uAycMw',
      youtubethumb: '/assets/images/support/thumbs/changingpossession.jpg',
      description: `Distribute the ball with passes, pitches, or handoffs`
    },
    {
      title: 'Moving the Line of Scrimmage',
      youtubeid: 'UNtf76GOIPU',
      youtubethumb: '/assets/images/support/thumbs/movingthelos.jpg',
      description: `Adjust the line of scrimmage for red zone, coming out, field and boundary plays`
    },
    {
      title: 'Creating Formations',
      youtubeid: 'Qaeeu5El3lg',
      youtubethumb: '/assets/images/support/thumbs/creatingformations.jpg',
      description: `Create offense and defense formations using your terminology`
    },
    {
      title: 'Creating Plays',
      youtubeid: '2xC0vYiOUao',
      youtubethumb: '/assets/images/support/thumbs/creatingplays.jpg',
      description: `Draw plays by matching offense formations to defensive fronts`
    },
    {
      title: 'Adding Shifts',
      youtubeid: 'Z0XUMsdi92s',
      youtubethumb: '/assets/images/support/thumbs/addinghuddlesandshifts.jpg',
      description: `Create huddles for realistic timing and add shifts to challenge players`
    },
    {
      title: 'Using Route Trees and First Steps',
      youtubeid: 'qZX2vGkjAsI',
      youtubethumb:
        '/assets/images/support/thumbs/usingroutetreesandfirststeps.jpg',
      description: `Use route trees to streamline play creation`
    }
  ];

  socialMediaLinks$: Observable<SocialMediaLinks> = this.store.select(
    fromRoot.getSocialMediaLinks
  );
  socialMediaLinksSubscription: Subscription = new Subscription();
  socialMediaLinks?: SocialMediaLinks;

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    this.store.dispatch(support.ToggleSupportPageAction('football'));

    this.socialMediaLinksSubscription = this.socialMediaLinks$.subscribe(
      (links) => {
        this.socialMediaLinks = links;
      }
    );
  }

  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    section!.scrollIntoView({ behavior: 'smooth' });
  }

  showModal(id: string, show?: boolean): void {
    this.store.dispatch(youtubeModal.ChangeVideoIdAction(id));
  }
}
